import { cookieWithConverter } from '@axo/shared/util/cookie';
import { track } from '@axo/site/util/tracking';

export const storeUTM = () => {
  if (typeof window === 'undefined') return;

  const trackCookieName = 'axotc';
  const lifetime = 180; // days

  const trackingData = track(document.referrer, window.location.search, {
    Bing: 'Bing Search',
    Google: 'Google Search',
  });

  if (!trackingData) return;

  cookieWithConverter.set(trackCookieName, trackingData, {
    expires: lifetime,
    path: '/',
    domain: window.location.host,
  });
};
